var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 34,
    viewBox: "0 0 96 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4731_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5352 16.9787C28.5558 18.5246 28.2671 20.0591 27.6857 21.4929C27.1043 22.9268 26.2419 24.2313 25.1487 25.3307C24.0555 26.43 22.7534 27.3022 21.318 27.8964C19.8827 28.4906 18.3428 28.795 16.788 28.7919C15.2332 28.7888 13.6946 28.4783 12.2616 27.8783C10.8287 27.2784 9.53003 26.401 8.44128 25.2973C7.35254 24.1936 6.49543 22.8857 5.91984 21.4495C5.34425 20.0133 5.06168 18.4777 5.08856 16.9319C5.06874 15.3879 5.35613 13.8552 5.93422 12.4221C6.5123 10.9889 7.36966 9.68358 8.45697 8.58113C9.54429 7.47868 10.8401 6.60088 12.2698 5.99825C13.6996 5.39561 15.2351 5.08002 16.7879 5.06964V0C14.5633 0.0149718 12.3636 0.466441 10.3149 1.32852C8.26611 2.1906 6.40865 3.44633 4.84898 5.02371C3.28932 6.60108 2.05813 8.46908 1.22602 10.5206C0.393906 12.5721 -0.022764 14.7667 -9.92185e-05 16.9787C-0.0379081 21.4438 1.70951 25.7411 4.8578 28.9252C8.00609 32.1094 12.2974 33.9196 16.7879 33.9579C19.015 33.9438 21.2175 33.4933 23.2694 32.6321C25.3213 31.7709 27.1823 30.5159 28.7459 28.9389C30.3096 27.3619 31.5453 25.4939 32.3823 23.4417C33.2193 21.3894 33.6412 19.1932 33.6238 16.9787H28.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.507 15.7786L31.9137 9.10913L33.5291 13.6016L15.124 20.2235L13.507 15.7786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0022 33.9582V0.0493925L43.422 0.00183105L53.9802 27.242L64.6332 0.00183105L71.7677 0.0493925V33.9582L67.2018 33.8155L67.1079 5.20272L55.7399 33.9582H51.9838L40.4724 5.20272V33.9582H36.0022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4348 9.12838C89.9147 6.1305 88.4806 3.92598 84.6781 3.92598C82.6647 3.92598 79.667 5.07246 79.667 8.2031C79.667 11.1138 82.1722 12.3487 83.2457 12.8343L89.777 15.7438C91.7967 16.65 93.5072 18.1215 94.6996 19.9786C95.4751 21.3014 95.8626 22.8137 95.8182 24.3442C95.8685 25.7266 95.6051 27.1025 95.0474 28.3698C94.4897 29.637 93.6521 30.7631 92.5968 31.6644C90.6181 33.3235 88.065 34.1468 85.4837 33.9582C82.7653 33.9415 80.1266 33.0433 77.9682 31.4C76.3686 30.0842 75.1104 28.4055 74.2994 26.5052L78.237 24.0785C79.1753 26.6812 81.3674 29.9003 85.7959 29.9003C88.5707 29.9003 91.5684 28.225 91.5684 24.6962C91.5684 23.1977 90.9874 21.3011 87.5407 19.7582L81.7256 17.1548C79.7121 16.2743 77.3421 14.6417 76.3129 12.8343C75.607 11.442 75.2683 9.89409 75.3287 8.33594C75.3287 3.44112 79.5335 0 84.6781 0C89.6885 0 93.2688 2.46978 95.2815 6.88064L91.4348 9.12838Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4731_2508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.8182,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGsm);
export default __webpack_public_path__ + "static/media/logo_gsm.512a9cd5e01911fa33470113ce4d46a4.svg";
export { ForwardRef as ReactComponent };